module.exports = __webpack_public_path__ + "static/la-ventures--jasmine-chiu-5c1382fbc2705b851ab752f7e6d26a39.mp4";